import makeStyles from "@mui/styles/makeStyles";
import { APP_DRAWER_ICON_WIDTH } from "../app/AppDrawer";

export const navItemListStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
  },

  more: {
    marginLeft: theme.spacing(1),
    color: theme.palette.text.secondary,
    fontSize: 14,
    fontWeight: 500,
    padding: theme.spacing(0.5),
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),

    "&:hover": {
      background: "none !important",
    },

    "& svg": {
      width: theme.spacing(2),
      height: theme.spacing(2),
    },
  },
}));

export const navItemListItemStyles = makeStyles((theme) => ({
  root: {
    fontSize: 14,
    fontWeight: 700,
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.text.secondary,
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0.5, 0),
    paddingLeft: `${APP_DRAWER_ICON_WIDTH}px`,
    borderRadius: theme.spacing(0.5),
    textTransform: "uppercase",
    margin: theme.spacing(1, 0),

    "& span": {
      maxWidth: theme.spacing(18),
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      display: "block",
      overflow: "hidden",
    },
  },

  active: {
    color: theme.palette.primary.main,
    backgroundColor: `${theme.palette.primary.main}19`,

    "&:hover": {
      backgroundColor: `${theme.palette.primary.main}40`,
    },
  },

  icon: {
    marginRight: theme.spacing(1),
  },
}));
